<template>
  <div class="flex flex-row items-center gap-2 px-3">
    <router-link class="flex-1" :to="generateRoute()">
      <button
        type="button"
        class="inline-flex items-center rounded border border-gray-300 bg-white px-2.5 py-1.5 text-xs font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 dark:border-white dark:bg-slate-700 dark:text-white"
      >
        {{ dossier[column.field].label }}
        <FontAwesomeIcon
          :icon="['fal', 'external-link']"
          size="sm"
          class="ml-2 flex-shrink-0 cursor-pointer"
        />
      </button>
    </router-link>
  </div>
</template>
<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'DashboardLink',
  components: { FontAwesomeIcon },
  props: {
    column: {
      type: Object,
      required: true
    },
    dossier: {
      type: Object,
      required: true
    }
  },
  methods: {
    generateRoute() {
      if (
        this.dossier[this.column.field].route_name === 'dossier_invoicing_route'
      ) {
        return '/dossier/' + this.dossier[this.column.field].id + '/invoicing'
      } else {
        return {
          name: this.dossier[this.column.field].route_name,
          params: { id: this.dossier[this.column.field].id }
        }
      }
    }
  }
}
</script>
